export default __webpack_public_path__ + "static/media/hero-image.540d394d.jpg";